import React, { useEffect, useState } from 'react';
import Conditional from '../../common/conditional';

import { concatClassNames } from '../../../utils/utilities';

import classNames from './zippy.module.scss';
import toastService from '../../../services/toastService';

interface ZippyProps {
	children: React.ReactNode;
	headerTitle: string;
	isValid?: boolean;
	showIcon?: boolean;
}

const Zippy: React.FC<ZippyProps> = ({
	children,
	headerTitle,
	isValid,
	showIcon = true,
}) => {
	const [isOpen, setIsOpen] = useState<boolean>(false);

	const handleToggle = (): void => {
		setIsOpen((prev: boolean) => !prev);
	};

	const renderButtonIcon = () => {
		const className = isOpen ? 'up' : 'down';
		return <i className={'bi bi-chevron-' + className}></i>;
	};

	const renderValidityIcon = () => {
		const className = isValid
			? classNames['zippy-success']
			: classNames['zippy-error'];

		return (
			<Conditional isVisible={showIcon}>
				<span className={className}>
					<i className={`bi bi-${isValid ? 'check2-circle' : 'x-circle'}`}></i>
				</span>
			</Conditional>
		);
	};

	const getZippyBodyClassNames = () => {
		return concatClassNames([
			classNames['zippy-body'],
			isOpen ? '' : classNames['zippy-body-hidden'],
		]);
	};

	useEffect(() => {
		const notifySectionCompleted = (): void => {
			if (!isValid) return;

			const title: string = headerTitle + ' Section Completed Successfully!';
			toastService.success(title);
		};

		notifySectionCompleted();
	}, [isValid, headerTitle]);

	return (
		<div className={`${classNames.zippy} ${isOpen ? '' : classNames.opaque}`}>
			<div className={classNames['zippy-header'] + ' d-flex'}>
				{renderValidityIcon()}

				<div className="w-100 text-capitalize px-4">{headerTitle}</div>

				<button
					onClick={handleToggle}
					className={classNames['zippy-header-toggle']}
				>
					{renderButtonIcon()}
				</button>
			</div>

			<Conditional isVisible={isOpen}>
				<div className={getZippyBodyClassNames()}>{children}</div>
			</Conditional>
		</div>
	);
};

export default Zippy;
